import React from 'react';

import AdminActivityPage from './AdminActivityPage';

const AdminGroupTwoActivityPage: React.FC = () => (
  <AdminActivityPage groupId="2" title="Group 2 User Activity" />
);

export default AdminGroupTwoActivityPage;
